import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import Sidebar from '../elements/Sidebar.jsx'
import Controller from '../elements/Controller.jsx'
import MetricHeader from '../elements/MetricHeader.jsx'
import MainLayout from '../elements/MainLayout.jsx'
import ModalManager from '../elements/ModalManager.jsx'

import ReceiveDollar from '../media/icons/icons8-receive-dollar-96.png'
import RequestMoney from '../media/icons/icons8-request-money-96.png'
import Contract from '../media/icons/icons8-contract-96.png'
import Save from '../media/icons/icons8-save-96.png'
import Delete from '../media/icons/icons8-delete-96.png'
import Approve from '../media/icons/icons8-approve-96.png'
import Deny from '../media/icons/icons8-cancel-96.png'

import Button from '../elements/Button.jsx'
import Counter from '../elements/Counter.jsx'
import TextInput from '../elements/TextInput.jsx'
import Table from '../elements/Table.jsx'
import IconButton from '../elements/IconButton.jsx'
import Dropdown from '../elements/ReactSelectDropdown.jsx'
import ParentSelector from '../elements/ParentSelector.jsx'
import Notification from '../elements/Notification.jsx'

import ManageTemplate from '../assets/thursdayreporting/ManageTemplates.jsx'
import SaveTemplate from '../assets/thursdayreporting/SaveTemplate.jsx'

import DenyReport from '../assets/DenyConfirm.jsx'
import EditReport from '../assets/thursdayReportingOS/EditReport.jsx'

import Edit from '../media/icons/icons8-edit-96.png'

import { useCookies } from 'react-cookie'

const Main = (props) => {

    const [refresh, setRefresh] = useState(false)

    const refreshData = () => {
        setRefresh((refresh) => !refresh)
    }

    function getCurrentTimeFormatted() {
        const now = new Date();
  
        let hours = now.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        hours = hours % 12; // Convert to 12-hour format
        hours = hours ? hours : 12; // The hour '0' should be '12'
        
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
      
        return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    }

    const [cookies, setCookies] = useCookies([])

    const buttonList = [
        {
            name: 'Approve Selected Reports',
            link: '',
            onClick: () => {submitSelectedReports()},
        },
        // {
        //     name: 'Show Table Data',
        //     link: '',
        //     onClick: () => {showTableData()},
        // },
    ]

    const [editReportModal, setEditReportModal] = useState(false)

    const headerData = [
        {
            image: ReceiveDollar,
            title: 'Weekly Gross',
            change: 7,
            total: 21750,
        },
        {
            image: RequestMoney,
            title: 'Weekly Net',
            change: 5,
            total: 12275,
        },
        {
            image: Contract,
            title: 'Weekly Contracts',
            change: 12,
            total: 24.5,
        },
        {
            image: Contract,
            title: 'Monthly Contracts',
            change: -3,
            total: 123,
        },
    ]

    const dealers2 = [
        { value: '4 Season Motors', label: '4 Season Motors' },
        { value: 'Chopper City', label: 'Chopper City' },
        { value: 'Auto Station', label: 'Auto Station' },
        { value: 'Duke City Auto LLC', label: 'Duke City Auto LLC' },
        { value: 'Pitre Buick GMC', label: 'Pitre Buick GMC' },
        { value: 'Sunset Motors', label: 'Sunset Motors' },
        { value: 'Speedy Wheels', label: 'Speedy Wheels' },
        { value: 'Elite Autos', label: 'Elite Autos' },
        { value: 'Golden Motors', label: 'Golden Motors' },
        { value: 'Thunder Auto', label: 'Thunder Auto' },
        { value: 'Cityscape Cars', label: 'Cityscape Cars' },
        { value: 'Majestic Motors', label: 'Majestic Motors' },
        { value: 'Eagle Eye Autos', label: 'Eagle Eye Autos' },
        { value: 'Sprint Auto Solutions', label: 'Sprint Auto Solutions' },
        { value: 'Grand Prix Motors', label: 'Grand Prix Motors' },
        { value: 'Royal Wheels', label: 'Royal Wheels' },
        { value: 'Pinnacle Cars', label: 'Pinnacle Cars' },
        { value: 'Prime Drive', label: 'Prime Drive' },
        { value: 'Dynamic Motors', label: 'Dynamic Motors' },
        { value: 'Precision Auto', label: 'Precision Auto' },
        { value: 'Evergreen Vehicles', label: 'Evergreen Vehicles' },
        { value: 'Blue Ribbon Autos', label: 'Blue Ribbon Autos' },
        { value: 'Safari Motors', label: 'Safari Motors' },
        { value: 'Vanguard Auto', label: 'Vanguard Auto' },
        { value: 'Velocity Motors', label: 'Velocity Motors' },
        { value: 'Omega Cars', label: 'Omega Cars' },
        { value: 'Supreme Autos', label: 'Supreme Autos' },
        { value: 'Victory Vehicles', label: 'Victory Vehicles' },
        { value: 'Zenith Motors', label: 'Zenith Motors' }
    ]

    const [tableTitles, setTableTitles] = useState([
        {
            title: 'Quantity',
            displayElement: (props) => (<Counter allowNegative={false} onChange={props.onChange} indexParent={props.indexParent} colors={props.colors} index={props.index} Style={{maxHeight: '35px'}}>{props.data}</Counter>),
            default: 0,
        },
        {
            title: 'Dealer',
            sortFunction: (curSortValue, sortState) => {setSortIndex(1); updateSort('dealership_ID', sortState, curSortValue)},
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap', fontWeight: '600', fontSize: '14px', maxWidth: '350px', overflow: 'hidden', textOverflow: 'ellipsis'}}>{props.data}</span>),
            default: 'No reports to approve',
        },
        {
            title: 'Admin',
            sortFunction: (curSortValue, sortState) => {setSortIndex(2); updateSort('admin_ID', sortState, curSortValue)},
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Subagent',
            sortFunction: (curSortValue, sortState) => {setSortIndex(3); updateSort('submitted_by', sortState, curSortValue)},
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'C-Type',
            sortFunction: (curSortValue, sortState) => {setSortIndex(4); updateSort('contract_subtype', sortState, curSortValue)},
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Gross/C',
            sortFunction: (curSortValue, sortState) => {setSortIndex(5); updateSort('contract_gross', sortState, curSortValue)},
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>${props.data}</span>),
            default: 0,
        },
        {
            title: 'Approve / Edit / Deny',
            displayElement: (props) => (
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <IconButton onClick={() => submitSelectedReports(props.index, props.reportID, props.tableData)} Style={{backgroundColor: props.colors.primary, marginLeft: '10px'}} size={27} image={Approve} colors={props.colors}></IconButton>
                    <IconButton onClick={() => {setEditReportModal(true); setSelectedReportIndex(props.index)}} Style={{backgroundColor: props.colors.danger, marginLeft: '10px'}} size={27} image={Edit} colors={props.colors}></IconButton>
                    <IconButton onClick={() => {setDenyReportModal(true); setSelectedReportIndex(props.index)}} Style={{backgroundColor: props.colors.warning, marginLeft: '10px', marginRight: '10px'}} size={27} image={Deny} colors={props.colors}></IconButton>
                </div>),
            default: undefined,
        },
    ])

    const [sort, setSort] = useState('null')
    const [reverseSort, setReverseSort] = useState(false)
    const [sortIndex, setSortIndex] = useState(-1)

    const addRow = () => {
        console.log('Add Row!')
        setTableValues((tableValues) => tableValues.map((column, index) => [
            ...column,
            tableTitles[index].default
        ]))
        setRowSelected((rowSelected) => [...rowSelected, false]);
    }

    const templates = [
        {
            id: 0,
            name: "Template 1",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 200,
            value: 'Template 1',
            label: 'Template 1',
        },
        {
            id: 1,
            name: "Template 2",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 300,
            value: 'Template 2',
            label: 'Template 2',
        },
        {
            id: 2,
            name: "Template 3",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 400,
            value: 'Template 3',
            label: 'Template 3',
        },
        {
            id: 3,
            name: "Template 4",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 500,
            value: 'Template 4',
            label: 'Template 4',
        },
        {
            id: 4,
            name: "Template 5",
            dealer: '4 Season Motors',
            admin: 'Liberty Shield',
            contractType: 'VSC',
            grossPerContract: 2600,
            value: 'Template 5',
            label: 'Template 5',
        },
    ]

    const deleteRow = (index) => {
        console.log('Deleted Row')
        setTableValues((tableValues) => tableValues.map((column) => {
            return [...column.slice(0, index), ...column.slice(index + 1)];
        }))
        setRowSelected((rowSelected) => [...rowSelected.slice(0, index), ...rowSelected.slice(index + 1)])
    }

    const onTableChange = (e, y, x) => {
        //console.log('Table Updated', e, x, y)
        //console.log('TableData: ', tableData)
        setTableValues((tableValues) => tableValues.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.label;
                }
                return data;
            })
        }))
        setTableData((tableData) => tableData.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.value;
                }
                return data;
            })
        }))
    }

    const applyTemplate = (template, row) => {
        setTableValues((tableValues) => tableValues.map((column, indexX) => {
            if (indexX === 2) {column[row] = template.dealer}
            if (indexX === 3) {column[row] = template.admin}
            if (indexX === 4) {column[row] = template.contractType}
            if (indexX === 5) {column[row] = template.grossPerContract}
            return column;
        }))
    }

    const submitSelectedReports = (index, reportID, tableData) => {
        let indexArray = []
        console.log(index)
        if (index !== undefined)
        {
            approveReport([index], reportID, 0, tableData)
        }
        else
        {
            rowSelected.map((selected, index) => {
                if (selected) { indexArray.push(index) }
            })
            approveReport(indexArray, reportID, 1)
        }
    }

    const [rowSelected, setRowSelected] = useState([false])

    const [manageTemplateModal, setManageTemplateModal] = useState(false)
    const [manageSaveTemplateModal, setManageSaveTemplateModal] = useState(false)

    const [tableValues, setTableValues] = useState([
        [tableTitles[0].default], //Quantity
        [tableTitles[1].default], //Dealer
        [tableTitles[2].default], //Subagent
        [tableTitles[3].default], //Contract Type
        [tableTitles[4].default], //Gross/Contract
        [tableTitles[5].default], //Edit Buttons (Empty as they don't need data)
        [tableTitles[6].default], //Edit Buttons (Empty as they don't need data)
    ]) 
    
    const [tableData, setTableData] = useState([
        [tableTitles[0].default],
        [tableTitles[1].default],
        [tableTitles[2].default],
        [tableTitles[3].default],
        [tableTitles[4].default],
        [tableTitles[5].default],
        [tableTitles[6].default],
    ])

    const [dropdownData, setDropdownData] = useState([
        [[]],
        [[]],
        [[]],
        [dealers2], //admin
        [dealers2], //contract type
        [[]],
        [[]],
    ])

    const showTableData = () => {
        console.log(tableValues)
    }

    const parentSelectorArray = [
        {
            name: 'Liberty Shield',
        },
        {
            name: 'Liberty Shield',
        },
        {
            name: 'Liberty Shield',
        },
        {
            name: 'Liberty Shield',
        },
    ]

    const [parentSelectedItem, setParentSelectedItem] = useState(-1)
    const [denyReportModal, setDenyReportModal] = useState(false)

    const [reportID, setReportID] = useState('hmm')
    const [formattedID, setFormattedID] = useState('')

    useEffect(() => {
        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };

        let tempTableValues = [
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
        ]
    
        props.tokenSafeAPIRequest('/report/thursday_report/need_approval/Verification?fetch_links=true&sort_field=' + sort + '&reverse_sort=' + reverseSort, requestOptions, tokenValues, (result) => {
            console.log(result)
            let tempReportID = []
            result.map((report, index) => {
                tempTableValues[0].push(report.quantity)
                tempTableValues[1].push(report.dealership_ID.name)
                tempTableValues[2].push(report.admin_ID.code)
                tempTableValues[3].push(report.submitted_by.first_name + ' ' + report.submitted_by.last_name)
                tempTableValues[4].push(report.contract_subtype)
                tempTableValues[5].push(report.contract_gross)
                tempTableValues[6].push(report.status_message)
                tempTableValues[7].push('')
                tempTableValues[8].push(report.code)
                tempReportID.push([report.id, report.code])
            })
            setReportID(formatReportIDs(tempReportID))

            let newTempTableValues = (countDuplicateSubarrays(transposeArray(tempTableValues)))
            newTempTableValues.map((report, index) => {
                report[0][0] = report[1]
                report.pop()
            })
            let finalNewTempTableValues = transposeArray(transposeArray(newTempTableValues)[0])
            let tempData = [...finalNewTempTableValues] //needed to make copy otherwise it saves reference and then updates as finalNewTempTableValue changes from the rest of the function
            console.log(tempData)
            setTableData(tempData)
            setTableValues(tempData)
            setRowSelected((rowSelected) => new Array(tempData[0].length).fill('').map((report, index) => {
                return false
            }))
        })
    },[refresh, sort, reverseSort])

    const deleteReport = (reason) => {
        console.log("Delete Report", selectedReportIndex, reportID)
        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            'IDs': reportID[selectedReportIndex].ids,
            'rejection_reason': reason,
        });
    
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          redirect: 'follow',
          body: raw,
        };
       
        props.tokenSafeAPIRequest('/report/thursday_report/reject', requestOptions, tokenValues, (result,status) => {
            console.log(result)
            if (status === 200)
            {
                setDenyReportModal(false)
                setNotification('Denied Report Successfully at: ' + getCurrentTimeFormatted())
                refreshData()
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const approveReport = (reportIndex, currentReportIDs, location, tableData) => {

        let idArray = [];

        if (location === 0)
        {
            console.log(console.log(reportIndex, currentReportIDs, location))
            idArray=([checkQuantity2(reportIndex[0], currentReportIDs[reportIndex].ids, tableData)])
        }
        if (location === 1)
        {
            console.log(console.log(reportIndex, reportID, location))
            reportIndex.map((repIndex, index) => {
                idArray.push(checkQuantity(repIndex, reportID[repIndex].ids))
            })
        }
        console.log(idArray)

        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        // var raw = JSON.stringify(checkQuantity(reportIndex, reportID[reportIndex].ids));
        var raw = '';

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(idArray),
        };

        console.log(requestOptions)

        props.tokenSafeAPIRequest('/report/thursday_report/approve', requestOptions, tokenValues, (result,status) => {
            if (status === 200)
            {
                deleteRow(reportIndex)
                setNotification('Approved Report Successfully at: ' + getCurrentTimeFormatted())
                refreshData()
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    const checkQuantity = (index, ids) => {
        console.log(index, ids)
        let counter = tableData[0][index]
        let tempIds = []
        ids.map((id, index) => {
            if (counter > 0)
            {
                tempIds.push(id);
                counter--;
            }
        })
        console.log(tempIds)
        return tempIds;
    }

    const checkQuantity2 = (index, ids, currentTableData) => {
        console.log(index, ids)
        let counter = currentTableData[0][index]
        let tempIds = []
        ids.map((id, index) => {
            if (counter > 0)
            {
                tempIds.push(id);
                counter--;
            }
        })
        console.log(tempIds)
        return tempIds;
    }

    function formatReportIDs(originalArray) {
        const result = [];
      
        // Create a temporary object to store codes and their corresponding IDs
        const temp = {};
      
        originalArray.forEach(([id, code]) => {
          // If the code doesn't exist in the temp object, add it with an empty array
          if (!temp[code]) {
            temp[code] = [];
          }
      
          // Push the id to the corresponding code's array
          temp[code].push(id);
        });
      
        // Convert the temp object into the desired array format
        for (const [code, ids] of Object.entries(temp)) {
          result.push({ code, ids });
        }
      
        return result;
      }

    const transposeArray = (array) => {
        if (!array || !Array.isArray(array) || array.length === 0 || !Array.isArray(array[0])) {
            return [[''],['No New Reports'],[''],[''],[''],[''],[''],[''],['']];
        }
        return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
    };

    const countDuplicateSubarrays = (arrayOfArrays) => {
        const arrayMap = new Map();
      
        arrayOfArrays.forEach(subArray => {
          // Convert each subarray to a string to use as a unique key for comparison
          const key = JSON.stringify(subArray);
          if (arrayMap.has(key)) {
            arrayMap.set(key, arrayMap.get(key) + 1);
          } else {
            arrayMap.set(key, 1);
          }
        });
      
        // Convert the map back into an array of arrays with quantities
        return Array.from(arrayMap, ([key, value]) => [JSON.parse(key), value]);
    }

    const [notification, setNotification] = useState('')
    const [selectedReportIndex, setSelectedReportIndex] = useState('-1')

    const updateSort = (newField, sortState, curSortValue) => {
        if (newField === curSortValue)
        {
            if (sortState)
            {
                setSort('null')
                setReverseSort(false)
            }
            else {setReverseSort(() => {return !sortState})}
        }
        else {setSort(newField)}
    }

    const editReports = (newData, Ids, reason) => {
        let tokenValues = 
        {
            refresh_token: cookies['refresh_token'],
            refresh_token_expires: cookies['refresh_token_expires'],
            access_token: cookies['access_token'],
            access_token_expires: cookies['access_token_expires'],
        }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(newData);
    
        var requestOptions = {
          method: 'PATCH',
          headers: myHeaders,
          redirect: 'follow',
          body: raw,
        };
       
        props.tokenSafeAPIRequest('/report/thursday_report/' + Ids.code, requestOptions, tokenValues, (result,status) => {
            console.log(result)
            if (status === 200)
            {
                setEditReportModal(false)
                setNotification('Edited Report Successfully at: ' + getCurrentTimeFormatted())
                refreshData()
            } else {setNotification(props.getServerResponse(result))}
        })
    }

    return (
        <MainLayout buttonList={buttonList} headerData={headerData} colors={props.colors}>
            <Sidebar colors={props.colors} tab={0}></Sidebar>
            <Controller colors={props.colors} activeButton={true} buttonList={buttonList} title={"Verification Reports (OS)"} tokenSafeAPIRequest={props.tokenSafeAPIRequest}></Controller>
            <div></div>{/* <ParentSelector colors={props.colors} parentSelectedItem={parentSelectedItem} setParentSelectedItem={setParentSelectedItem} title={'Admins'} array={parentSelectorArray}></ParentSelector> */}
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <Table colors={props.colors} tableData={tableValues} tableInfo={tableTitles} reportID={reportID} dropdownData={dropdownData} rows={rowSelected} setRows={setRowSelected} onChange={onTableChange} approveReport={approveReport} reverseSort={reverseSort} sort={sort} sortIndex={sortIndex}></Table>
            </div>
            <ModalManager colors={props.colors}>
                <DenyReport isOpen={denyReportModal} setIsOpen={() => setDenyReportModal(false)} onClick={deleteReport} colors={props.colors}></DenyReport>
                <EditReport isOpen={editReportModal} setIsOpen={() => setEditReportModal(false)} onClick={editReports} reportIds={reportID[selectedReportIndex]} reportInfo={[tableValues?.[0]?.[selectedReportIndex], tableValues?.[5]?.[selectedReportIndex]]} colors={props.colors}></EditReport>
            </ModalManager>
            <Notification colors={props.colors} message={notification}></Notification>
        </MainLayout>
    )
}

export default Main
